import { Injectable } from '@angular/core';
import { AuthStateService } from './auth-state.service';
import { ApiService } from './api.service';
import { BehaviorSubject, Subscription, catchError, of, switchMap, timer } from 'rxjs';

const POLLING_INTERVAL = 60; // seconds

interface BillingStatus {
  status?: string;
  bookbutton?: boolean;
  remaining?: number;
}

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  private polling: Subscription = null;
  private data: BillingStatus | null = null;

  private endingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public ending$ = this.endingSubject.asObservable();
  private depletedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public depleted$ = this.depletedSubject.asObservable();
  private remainingSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public remaining$ = this.remainingSubject.asObservable();

  constructor(
    private auth: AuthStateService,
    private api: ApiService
  ) { }

  public init(): void {
    if (this.auth.hasFeature('billing')) {
      if (this.polling === null) {
        this.polling = timer(0, POLLING_INTERVAL * 1000)
          .pipe(
            switchMap(() => {
              return this.api.getBillingStatus().pipe(
                catchError(() => {
                  return of(null);
                })
              );
            })
          )
          .subscribe({
            next: (result: any) => {
              this.data = result?.data || null;
              this.endingSubject.next(this.data?.status === 'ending');
              this.depletedSubject.next(this.data?.status === 'depleted');
              this.remainingSubject.next(this.data?.remaining);
            }
          });
      }
    }
  }

}
